'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('@slate-editor/components');

var _ItalicUtils = require('./ItalicUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItalicButton = function ItalicButton(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      className = _ref.className,
      style = _ref.style,
      type = _ref.type;
  return _react2.default.createElement(
    _components.Button,
    {
      style: style,
      type: type,
      onClick: function onClick() {
        return onChange((0, _ItalicUtils.italicMarkStrategy)(value.change()));
      },
      className: (0, _classnames2.default)('slate-italic-plugin--button', { active: (0, _ItalicUtils.hasMark)(value) }, className)
    },
    _react2.default.createElement(_reactFontawesome2.default, { name: 'italic' })
  );
}; /* eslint-disable react/prop-types */
exports.default = ItalicButton;